/* Порядок пунктов рельса — личная настройка пользователя, потребитель общего хранилища
   lib/userPrefs.ts (один GET /api/prefs на сессию, ключ "rail_order"). Локальное хранилище
   здесь — только мгновенный кеш ПЕРВОГО кадра (до ответа сервера), не второй источник истины:
   fetchRailOrder всегда идёт через loadAllPrefs и перезаписывает то, что показал кеш. */
import { loadAllPrefs, setPref } from "./userPrefs";
const STORAGE_PREFIX = "osnova.railOrder.";
const PREFS_KEY = "rail_order";
// loadRailOrderCached — синхронное чтение мгновенного кеша (для первого рендера, до ответа
// сервера); не источник истины, только то, что успело осесть с прошлой сессии.
export function loadRailOrderCached(userId) {
    if (!userId)
        return [];
    try {
        const raw = localStorage.getItem(STORAGE_PREFIX + userId);
        if (!raw)
            return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed))
            return [];
        return parsed.filter((id) => typeof id === "string");
    }
    catch {
        return [];
    }
}
function cacheRailOrder(userId, ids) {
    try {
        localStorage.setItem(STORAGE_PREFIX + userId, JSON.stringify(ids));
    }
    catch {
        /* хранилище недоступно (приватный режим, квота) — кеш просто не переживёт перезагрузку */
    }
}
// fetchRailOrder — источник истины: берёт значение из общего loadAllPrefs (сеть трогает
// максимум один раз за сессию, дальше отдаёт из памяти) и обновляет локальный кеш первого
// кадра. Недоступность сервера/отсутствие ключа => пустой массив, порядок по умолчанию.
export async function fetchRailOrder(userId) {
    if (!userId)
        return [];
    const all = await loadAllPrefs();
    const raw = all[PREFS_KEY];
    if (!Array.isArray(raw))
        return [];
    const ids = raw.filter((id) => typeof id === "string");
    cacheRailOrder(userId, ids);
    return ids;
}
// saveRailOrder — пишет кеш немедленно (синхронно, для отзывчивости) и через общий setPref
// уходит на сервер в фоне; провал записи не роняет оболочку (см. lib/userPrefs.ts isPrefDirty).
export function saveRailOrder(userId, ids) {
    if (!userId)
        return;
    cacheRailOrder(userId, ids);
    setPref(PREFS_KEY, ids);
}
// Сохранённый порядок — это порядок ПОКАЗА поверх списка с сервера: новые id — в конец,
// пропавшие — игнорируются.
export function applyRailOrder(items, order) {
    if (!order.length)
        return items;
    const byId = new Map(items.map((it) => [it.id, it]));
    const ordered = [];
    for (const id of order) {
        const it = byId.get(id);
        if (it) {
            ordered.push(it);
            byId.delete(id);
        }
    }
    ordered.push(...items.filter((it) => byId.has(it.id)));
    return ordered;
}
